angular.module('content.widgets.studentNotesWidgetController', [
  'content.widgets.studentNotesWidgetService'
])

/**
 * Add student notes to service or restore notes from service.
 *
 * @class StudentNotesWidgetController
 * @constructor
 * @module content.widgets.StudentNotesWidgetController
 **/
.controller('studentNotesWidgetController', [
  '$scope',
  'studentNotesWidgetService',
  function ($scope, studentNotesWidgetService) {
    'use strict';

    $scope.setModel = function () {
      return studentNotesWidgetService.setModel($scope.model);
    };

    $scope.getModel = function () {
      return studentNotesWidgetService.getModel();
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      studentNotesWidgetService.setLabel($scope.model.label);
      $scope.model = studentNotesWidgetService.getModel();
      // emits an event passing the current scope.  This scope is picked up by the
      // associated theme to register as the active scope.
      // This event is required to initialize a widget
      $scope.$emit('setCurrentContentScope', $scope);
    }

    initialize();
  }
]);
